import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class ConfigService {
  // GLOBAL URL
  public linebertyBookingServer: string = environment.linebertyBookingServer;
  public linebertyBookingApiVersionV1: string = environment.linebertyBookingApiVersionV1;
  public linebertyBookingApiVersionV2: string = environment.linebertyBookingApiVersionV2;
  public linebertyValidationServer: string = environment.linebertyValidationServer;
  public linebertyValidationApiVersion: string = environment.linebertyValidationApiVersion;
  public linebertyServerUrl: string = environment.linebertyServerUrl;
  public linebertyApiVersion: string = environment.linebertyApiVersion;
  public applicationServerUrl: string = environment.applicationServerUrl;
  public applicationServerVersion: string = environment.applicationServerVersion;
  public bookingServerUrl: string = environment.bookingServerUrl;
  public bookingServerVersion: string = environment.bookingServerVersion;
  public timetableServerUrl: string = environment.timetableServerUrl;
  public timetableServerVersion: string = environment.timetableServerVersion;
  public endpointServerUrl: string = environment.endpointServerUrl;
  public endpointServerVersion: string = environment.endpointServerVersion;
  public authentificationServerUrl: string = environment.authentificationServerUrl;
  public authentificationServerVersion: string = environment.authentificationServerVersion;
  // uat-validation.lineberty.net/api/v1/lineberty/b/apiKey

  // ROUTE FOR APPLICATION
  getApplicationById: string = this.applicationServerUrl + this.applicationServerVersion + '/applications/{applicationId}';
  sendError: string = this.applicationServerUrl + this.applicationServerVersion + '/errors/';

  // ROUTE FOR AUTHENTICATION
  getSsoInformation: string = this.authentificationServerUrl + this.authentificationServerVersion + '/sso/ssoInformation';

  // ROUTE ON LINEBERTY SERVER
  getBookingApiKey: string = this.linebertyServerUrl + this.linebertyApiVersion + '/lineberty/b/apiKey';
  getValidationApiKey: string = this.linebertyServerUrl + this.linebertyApiVersion + '/lineberty/v/apiKey';
  createUser: string = this.linebertyServerUrl + this.linebertyApiVersion + '/lineberty/b/create';
  logUser: string = this.linebertyServerUrl + this.linebertyApiVersion + '/lineberty/b/login';
  refreshUserToken: string = this.linebertyServerUrl + this.linebertyApiVersion + '/lineberty/b/refreshToken';
  verifyJWT: string = this.linebertyServerUrl + this.linebertyValidationApiVersion + '/jwt/verify';

  getPlaceFromPlaceName: string = this.linebertyServerUrl + this.linebertyApiVersion + '/places/placeName/{placeName}';

  // ROUTE ON VALIDATION LINEBERTY SERVER
  preLogin: string = this.linebertyValidationServer + this.linebertyValidationApiVersion + '/operator/preLogin';
  loginOperator: string = this.linebertyValidationServer + this.linebertyValidationApiVersion + '/operator/endpoint/{endpointId}/login';
  assignToEndpoint: string = this.linebertyValidationServer + this.linebertyValidationApiVersion + '/operator/session/assignToEndpoint';
  logoutOperator: string = this.linebertyValidationServer + this.linebertyValidationApiVersion + '/operator/session';
  refreshOperatorToken: string = this.linebertyValidationServer + this.linebertyValidationApiVersion + '/operator/session/refreshToken';
  operatorRoles: string = this.linebertyValidationServer + this.linebertyValidationApiVersion + '/operator/roles';
  operatorAccount: string = this.linebertyValidationServer + this.linebertyValidationApiVersion + '/operator/account';

  getPlace: string = this.linebertyValidationServer + this.linebertyValidationApiVersion + '/places/{placeId}';
  getPlaceTimeslots: string = this.linebertyValidationServer + this.linebertyValidationApiVersion + '/places/{placeId}/timeslots';
  getQueue: string = this.linebertyValidationServer + this.linebertyValidationApiVersion + '/queues/{queueId}';
  getCounters: string = this.linebertyValidationServer + this.linebertyValidationApiVersion + '/counters';
  getQueueEndpoints: string = this.linebertyValidationServer + this.linebertyValidationApiVersion + '/queues/{queueId}/endpoints';
  getQueueEndpointsSSE: string = this.linebertyValidationServer + this.linebertyValidationApiVersion + '/queues/{queueId}/endpoints/sse';
  getEndpoint: string = this.linebertyValidationServer + this.linebertyValidationApiVersion + '/endpoints/{endpointId}';
  getEndpointSse: string = this.linebertyValidationServer + this.linebertyValidationApiVersion + '/endpoints/{endpointId}/sse';
  getEndpointTimeslots: string = this.linebertyValidationServer + this.linebertyValidationApiVersion + '/endpoints/{endpointId}/timeslots';
  setEndpointTimeslots: string = this.linebertyValidationServer + this.linebertyValidationApiVersion + '/endpoints/{endpointId}/timeslots';
  deleteEndpointTimeslots: string = this.linebertyValidationServer + this.linebertyValidationApiVersion + '/endpoints/{endpointId}/timeslots';
  getIndicators: string = this.linebertyValidationServer + this.linebertyValidationApiVersion + '/queues/{queueId}/indicators';
  openEndpoint: string = this.linebertyValidationServer + this.linebertyValidationApiVersion + '/endpoints/{endpointId}';
  getDoneTickets: string = this.linebertyValidationServer + this.linebertyValidationApiVersion + '/queues/{queueId}/tickets/history';
  getCurrentsTickets: string = this.linebertyValidationServer + this.linebertyValidationApiVersion + '/queues/{queueId}/tickets/currents';
  getCurrentsTicketsSse: string = this.linebertyValidationServer + this.linebertyValidationApiVersion + '/queues/{queueId}/tickets/currents/sse';
  getCounterSse: string = this.linebertyValidationServer + this.linebertyValidationApiVersion + '/counters/sse';
  incrementCounter: string = this.linebertyValidationServer + this.linebertyValidationApiVersion + '/counters/{counterId}';
  decrementCounter: string = this.linebertyValidationServer + this.linebertyValidationApiVersion + '/counters/{counterId}';
  searchTickets: string = this.linebertyValidationServer + this.linebertyValidationApiVersion + '/queues/{queueId}/tickets/search';
  setTicketExtendedAttributes: string = this.linebertyValidationServer + this.linebertyValidationApiVersion + '/tickets/{ticketId}/extendedAttributes';
  setTicketState: string = this.linebertyValidationServer + this.linebertyValidationApiVersion + '/tickets/{ticketId}/states';
  getTicketLife: string = this.linebertyValidationServer + this.linebertyValidationApiVersion + '/tickets/{ticketId}/life';
  getTicketSms: string = this.linebertyValidationServer + this.linebertyValidationApiVersion + '/tickets/{ticketId}/sms';

  // ROUTE FOR BOOKING LINEBERTY SERVER
  getTicketsV1: string = this.linebertyBookingServer + this.linebertyBookingApiVersionV1 + '/user/tickets';
  getQueuesOfPlaceV1: string = this.linebertyBookingServer + this.linebertyBookingApiVersionV1 + '/places/{placeId}/queues';
  getQueueAvailabilitiesV1: string = this.linebertyBookingServer + this.linebertyBookingApiVersionV1 + '/queues/{queueId}/appointmentTypes/{appointmentTypeId}/groupSize/{groupSize}/availabilities';
  getQueueBookingV1: string = this.linebertyBookingServer + this.linebertyBookingApiVersionV1 + '/queues/{queueId}';
  getQueuesStateSseV1: string = this.linebertyBookingServer + this.linebertyBookingApiVersionV1 + '/queues/state/sse';
  bookingTicketV1: string = this.linebertyBookingServer + this.linebertyBookingApiVersionV1 + '/queues/{queueId}/ticket';
  cancelTicketV1: string = this.linebertyBookingServer + this.linebertyBookingApiVersionV1 + '/user/tickets/{ticketId}/cancel';

  getTicketsV2: string = this.linebertyBookingServer + this.linebertyBookingApiVersionV2 + '/user/tickets';
  getQueuesOfPlaceV2: string = this.linebertyBookingServer + this.linebertyBookingApiVersionV2 + '/places/{placeId}/queues';
  getQueueAvailabilitiesV2: string = this.linebertyBookingServer + this.linebertyBookingApiVersionV2 + '/queues/{queueId}/availabilities';
  getQueueDaysWithAvailabilitiesV2: string = this.linebertyBookingServer + this.linebertyBookingApiVersionV2 + '/queues/{queueId}/daysWithAvailabilities';
  getQueueBookingV2: string = this.linebertyBookingServer + this.linebertyBookingApiVersionV2 + '/queues/{queueId}';
  getQueuesStateSseV2: string = this.linebertyBookingServer + this.linebertyBookingApiVersionV2 + '/queues/state/sse';
  bookingTicketV2: string = this.linebertyBookingServer + this.linebertyBookingApiVersionV2 + '/queues/{queueId}/ticket';
  cancelTicketV2: string = this.linebertyBookingServer + this.linebertyBookingApiVersionV2 + '/user/tickets/{ticketId}/cancel';

  // QUEUES VERSIONS
  getQueueVersion: string = this.bookingServerUrl + this.bookingServerVersion + '/queues/versions';

  // PATCH BOOKING OPENING ROUTE
  openBooking: string = this.timetableServerUrl + this.timetableServerVersion + '/queueBooking/{queueId}/openBookingForTheDay';
  closeBooking: string = this.timetableServerUrl + this.timetableServerVersion + '/queueBooking/{queueId}/closeBookingForTheDay';

  // ENDPOINT CONFIG ROUTE
  getEndpointConfig: string = this.endpointServerUrl + this.endpointServerVersion + '/endpoints/{endpointId}/configuration';

  //
  getNextQueueAppointmentType: string = this.bookingServerUrl + this.bookingServerVersion + '/queues/{queueId}/nextAppointment';

  // CONFIG
  defaultTimezone: string = 'Europe/Paris';
  defaultLang: string = 'fr_FR';
  favoriteCountryCode: any = ['FR', 'BE', 'JP'];
  defaultCountryCode: string = 'FR';
  supportedLanguage: any = ['fr_FR', 'en_US'];
  supportedClientLanguage: any = ['fr_FR', 'en_US'];
  sourceBookingTicket: string = 'LINEBERTY_ENDPOINT_WEB_APP';
  webappName: string = 'LINEBERTY_ENDPOINT_WEB_APP';
  defaultHttpTimeout: number = 1000 * 5;
  bigtHttpTimeout: number = 1000 * 10;
  maxTicketDisplay: number = 25;
  showStateName: boolean = false;
  showTicketLang: boolean = false;
  searchWithoutFilter: boolean = false;
  showConfirmationOnSetState = {
    '0': false,
    '50': false,
    '100': false,
    '200': false,
    '300': true,
    '400': true,
    '500': false,
    '600': true,
    '700': false,
  };
  webappPages = ['validation', 'login', 'debug', 'covid', 'scan'];

  countryCodes: any = [
    { name: { en: 'Afghanistan' }, countryCode: '93', i10n: 'AF' },
    { name: { en: 'Albania' }, countryCode: '355', i10n: 'AL' },
    { name: { en: 'Algeria' }, countryCode: '213', i10n: 'DZ' },
    { name: { en: 'American Samoa' }, countryCode: '1-684', i10n: 'AS' },
    { name: { en: 'Andorra' }, countryCode: '376', i10n: 'AD' },
    { name: { en: 'Angola' }, countryCode: '244', i10n: 'AO' },
    { name: { en: 'Anguilla' }, countryCode: '1-264', i10n: 'AI' },
    { name: { en: 'Antarctica' }, countryCode: '672', i10n: 'AQ' },
    { name: { en: 'Antigua and Barbuda' }, countryCode: '1-268', i10n: 'AG' },
    { name: { en: 'Argentina' }, countryCode: '54', i10n: 'AR' },
    { name: { en: 'Armenia' }, countryCode: '374', i10n: 'AM' },
    { name: { en: 'Aruba' }, countryCode: '297', i10n: 'AW' },
    { name: { en: 'Australia' }, countryCode: '61', i10n: 'AU' },
    { name: { en: 'Austria' }, countryCode: '43', i10n: 'AT' },
    { name: { en: 'Azerbaijan' }, countryCode: '994', i10n: 'AZ' },
    { name: { en: 'Bahamas' }, countryCode: '1-242', i10n: 'BS' },
    { name: { en: 'Bahrain' }, countryCode: '973', i10n: 'BH' },
    { name: { en: 'Bangladesh' }, countryCode: '880', i10n: 'BD' },
    { name: { en: 'Barbados' }, countryCode: '1-246', i10n: 'BB' },
    { name: { en: 'Belarus' }, countryCode: '375', i10n: 'BY' },
    { name: { en: 'Belgium' }, countryCode: '32', i10n: 'BE' },
    { name: { en: 'Belize' }, countryCode: '501', i10n: 'BZ' },
    { name: { en: 'Benin' }, countryCode: '229', i10n: 'BJ' },
    { name: { en: 'Bermuda' }, countryCode: '1-441', i10n: 'BM' },
    { name: { en: 'Bhutan' }, countryCode: '975', i10n: 'BT' },
    { name: { en: 'Bolivia' }, countryCode: '591', i10n: 'BO' },
    { name: { en: 'Bosnia and Herzegovina' }, countryCode: '387', i10n: 'BA' },
    { name: { en: 'Botswana' }, countryCode: '267', i10n: 'BW' },
    { name: { en: 'Brazil' }, countryCode: '55', i10n: 'BR' },
    { name: { en: 'British Indian Ocean Territory' }, countryCode: '246', i10n: 'IO' },
    { name: { en: 'British Virgin Islands' }, countryCode: '1-284', i10n: 'VG' },
    { name: { en: 'Brunei' }, countryCode: '673', i10n: 'BN' },
    { name: { en: 'Bulgaria' }, countryCode: '359', i10n: 'BG' },
    { name: { en: 'Burkina Faso' }, countryCode: '226', i10n: 'BF' },
    { name: { en: 'Burundi' }, countryCode: '257', i10n: 'BI' },
    { name: { en: 'Cambodia' }, countryCode: '855', i10n: 'KH' },
    { name: { en: 'Cameroon' }, countryCode: '237', i10n: 'CM' },
    { name: { en: 'Canada' }, countryCode: '1', i10n: 'CA' },
    { name: { en: 'Cape Verde' }, countryCode: '238', i10n: 'CV' },
    { name: { en: 'Cayman Islands' }, countryCode: '1-345', i10n: 'KY' },
    { name: { en: 'Central African Republic' }, countryCode: '236', i10n: 'CF' },
    { name: { en: 'Chad' }, countryCode: '235', i10n: 'TD' },
    { name: { en: 'Chile' }, countryCode: '56', i10n: 'CL' },
    { name: { en: 'China' }, countryCode: '86', i10n: 'CN' },
    { name: { en: 'Christmas Island' }, countryCode: '61', i10n: 'CX' },
    { name: { en: 'Cocos Islands' }, countryCode: '61', i10n: 'CC' },
    { name: { en: 'Colombia' }, countryCode: '57', i10n: 'CO' },
    { name: { en: 'Comoros' }, countryCode: '269', i10n: 'KM' },
    { name: { en: 'Cook Islands' }, countryCode: '682', i10n: 'CK' },
    { name: { en: 'Costa Rica' }, countryCode: '506', i10n: 'CR' },
    { name: { en: 'Croatia' }, countryCode: '385', i10n: 'HR' },
    { name: { en: 'Cuba' }, countryCode: '53', i10n: 'CU' },
    { name: { en: 'Curacao' }, countryCode: '599', i10n: 'CW' },
    { name: { en: 'Cyprus' }, countryCode: '357', i10n: 'CY' },
    { name: { en: 'Czech Republic' }, countryCode: '420', i10n: 'CZ' },
    { name: { en: 'Democratic Republic of the Congo' }, countryCode: '243', i10n: 'CD' },
    { name: { en: 'Denmark' }, countryCode: '45', i10n: 'DK' },
    { name: { en: 'Djibouti' }, countryCode: '253', i10n: 'DJ' },
    { name: { en: 'Dominica' }, countryCode: '1-767', i10n: 'DM' },
    { name: { en: 'Dominican Republic' }, countryCode: '1-809', i10n: 'DO' },
    { name: { en: 'Dominican Republic' }, countryCode: '1-829', i10n: 'DO' },
    { name: { en: 'Dominican Republic' }, countryCode: '1-849', i10n: 'DO' },
    { name: { en: 'East Timor' }, countryCode: '670', i10n: 'TL' },
    { name: { en: 'Ecuador' }, countryCode: '593', i10n: 'EC' },
    { name: { en: 'Egypt' }, countryCode: '20', i10n: 'EG' },
    { name: { en: 'El Salvador' }, countryCode: '503', i10n: 'SV' },
    { name: { en: 'Equatorial Guinea' }, countryCode: '240', i10n: 'GQ' },
    { name: { en: 'Eritrea' }, countryCode: '291', i10n: 'ER' },
    { name: { en: 'Estonia' }, countryCode: '372', i10n: 'EE' },
    { name: { en: 'Ethiopia' }, countryCode: '251', i10n: 'ET' },
    { name: { en: 'Falkland Islands' }, countryCode: '500', i10n: 'FK' },
    { name: { en: 'Faroe Islands' }, countryCode: '298', i10n: 'FO' },
    { name: { en: 'Fiji' }, countryCode: '679', i10n: 'FJ' },
    { name: { en: 'Finland' }, countryCode: '358', i10n: 'FI' },
    { name: { en: 'France' }, countryCode: '33', i10n: 'FR' },
    { name: { en: 'French Polynesia' }, countryCode: '689', i10n: 'PF' },
    { name: { en: 'Gabon' }, countryCode: '241', i10n: 'GA' },
    { name: { en: 'Gambia' }, countryCode: '220', i10n: 'GM' },
    { name: { en: 'Georgia' }, countryCode: '995', i10n: 'GE' },
    { name: { en: 'Germany' }, countryCode: '49', i10n: 'DE' },
    { name: { en: 'Ghana' }, countryCode: '233', i10n: 'GH' },
    { name: { en: 'Gibraltar' }, countryCode: '350', i10n: 'GI' },
    { name: { en: 'Greece' }, countryCode: '30', i10n: 'GR' },
    { name: { en: 'Greenland' }, countryCode: '299', i10n: 'GL' },
    { name: { en: 'Grenada' }, countryCode: '1-473', i10n: 'GD' },
    { name: { en: 'Guadeloupe' }, countryCode: '590', i10n: 'GP' },
    { name: { en: 'Guam' }, countryCode: '1-671', i10n: 'GU' },
    { name: { en: 'Guatemala' }, countryCode: '502', i10n: 'GT' },
    { name: { en: 'Guernsey' }, countryCode: '44-1481', i10n: 'GG' },
    { name: { en: 'Guinea' }, countryCode: '224', i10n: 'GN' },
    { name: { en: 'Guinea-Bissau' }, countryCode: '245', i10n: 'GW' },
    { name: { en: 'Guyana' }, countryCode: '592', i10n: 'GY' },
    { name: { en: 'French Guiana' }, countryCode: '594', i10n: 'GF', flagCode: 'FR' },
    { name: { en: 'Haiti' }, countryCode: '509', i10n: 'HT' },
    { name: { en: 'Honduras' }, countryCode: '504', i10n: 'HN' },
    { name: { en: 'Hong Kong' }, countryCode: '852', i10n: 'HK' },
    { name: { en: 'Hungary' }, countryCode: '36', i10n: 'HU' },
    { name: { en: 'Iceland' }, countryCode: '354', i10n: 'IS' },
    { name: { en: 'India' }, countryCode: '91', i10n: 'IN' },
    { name: { en: 'Indonesia' }, countryCode: '62', i10n: 'ID' },
    { name: { en: 'Iran' }, countryCode: '98', i10n: 'IR' },
    { name: { en: 'Iraq' }, countryCode: '964', i10n: 'IQ' },
    { name: { en: 'Ireland' }, countryCode: '353', i10n: 'IE' },
    { name: { en: 'Isle of Man' }, countryCode: '44-1624', i10n: 'IM' },
    { name: { en: 'Israel' }, countryCode: '972', i10n: 'IL' },
    { name: { en: 'Italy' }, countryCode: '39', i10n: 'IT' },
    { name: { en: 'Ivory Coast' }, countryCode: '225', i10n: 'CI' },
    { name: { en: 'Jamaica' }, countryCode: '1-876', i10n: 'JM' },
    { name: { en: 'Japan' }, countryCode: '81', i10n: 'JP' },
    { name: { en: 'Jersey' }, countryCode: '44-1534', i10n: 'JE' },
    { name: { en: 'Jordan' }, countryCode: '962', i10n: 'JO' },
    { name: { en: 'Kazakhstan' }, countryCode: '7', i10n: 'KZ' },
    { name: { en: 'Kenya' }, countryCode: '254', i10n: 'KE' },
    { name: { en: 'Kiribati' }, countryCode: '686', i10n: 'KI' },
    { name: { en: 'Kosovo' }, countryCode: '383', i10n: 'XK' },
    { name: { en: 'Kuwait' }, countryCode: '965', i10n: 'KW' },
    { name: { en: 'Kyrgyzstan' }, countryCode: '996', i10n: 'KG' },
    { name: { en: 'Laos' }, countryCode: '856', i10n: 'LA' },
    { name: { en: 'Latvia' }, countryCode: '371', i10n: 'LV' },
    { name: { en: 'Lebanon' }, countryCode: '961', i10n: 'LB' },
    { name: { en: 'Lesotho' }, countryCode: '266', i10n: 'LS' },
    { name: { en: 'Liberia' }, countryCode: '231', i10n: 'LR' },
    { name: { en: 'Libya' }, countryCode: '218', i10n: 'LY' },
    { name: { en: 'Liechtenstein' }, countryCode: '423', i10n: 'LI' },
    { name: { en: 'Lithuania' }, countryCode: '370', i10n: 'LT' },
    { name: { en: 'Luxembourg' }, countryCode: '352', i10n: 'LU' },
    { name: { en: 'Macau' }, countryCode: '853', i10n: 'MO' },
    { name: { en: 'Macedonia' }, countryCode: '389', i10n: 'MK' },
    { name: { en: 'Madagascar' }, countryCode: '261', i10n: 'MG' },
    { name: { en: 'Malawi' }, countryCode: '265', i10n: 'MW' },
    { name: { en: 'Malaysia' }, countryCode: '60', i10n: 'MY' },
    { name: { en: 'Maldives' }, countryCode: '960', i10n: 'MV' },
    { name: { en: 'Mali' }, countryCode: '223', i10n: 'ML' },
    { name: { en: 'Malta' }, countryCode: '356', i10n: 'MT' },
    { name: { en: 'Marshall Islands' }, countryCode: '692', i10n: 'MH' },
    { name: { en: 'Martinique' }, countryCode: '596', i10n: 'MQ', flagCode: 'FR' },
    { name: { en: 'Mauritania' }, countryCode: '222', i10n: 'MR' },
    { name: { en: 'Mauritius' }, countryCode: '230', i10n: 'MU' },
    { name: { en: 'Mayotte' }, countryCode: '262', i10n: 'YT', flagCode: 'FR' },
    { name: { en: 'Mexico' }, countryCode: '52', i10n: 'MX' },
    { name: { en: 'Micronesia' }, countryCode: '691', i10n: 'FM' },
    { name: { en: 'Moldova' }, countryCode: '373', i10n: 'MD' },
    { name: { en: 'Monaco' }, countryCode: '377', i10n: 'MC' },
    { name: { en: 'Mongolia' }, countryCode: '976', i10n: 'MN' },
    { name: { en: 'Montenegro' }, countryCode: '382', i10n: 'ME' },
    { name: { en: 'Montserrat' }, countryCode: '1-664', i10n: 'MS' },
    { name: { en: 'Morocco' }, countryCode: '212', i10n: 'MA' },
    { name: { en: 'Mozambique' }, countryCode: '258', i10n: 'MZ' },
    { name: { en: 'Myanmar' }, countryCode: '95', i10n: 'MM' },
    { name: { en: 'Namibia' }, countryCode: '264', i10n: 'NA' },
    { name: { en: 'Nauru' }, countryCode: '674', i10n: 'NR' },
    { name: { en: 'Nepal' }, countryCode: '977', i10n: 'NP' },
    { name: { en: 'Netherlands' }, countryCode: '31', i10n: 'NL' },
    { name: { en: 'Netherlands Antilles' }, countryCode: '599', i10n: 'AN' },
    { name: { en: 'New Caledonia' }, countryCode: '687', i10n: 'NC' },
    { name: { en: 'New Zealand' }, countryCode: '64', i10n: 'NZ' },
    { name: { en: 'Nicaragua' }, countryCode: '505', i10n: 'NI' },
    { name: { en: 'Niger' }, countryCode: '227', i10n: 'NE' },
    { name: { en: 'Nigeria' }, countryCode: '234', i10n: 'NG' },
    { name: { en: 'Niue' }, countryCode: '683', i10n: 'NU' },
    { name: { en: 'North Korea' }, countryCode: '850', i10n: 'KP' },
    { name: { en: 'Northern Mariana Islands' }, countryCode: '1-670', i10n: 'MP' },
    { name: { en: 'Norway' }, countryCode: '47', i10n: 'NO' },
    { name: { en: 'Oman' }, countryCode: '968', i10n: 'OM' },
    { name: { en: 'Pakistan' }, countryCode: '92', i10n: 'PK' },
    { name: { en: 'Palau' }, countryCode: '680', i10n: 'PW' },
    { name: { en: 'Palestine' }, countryCode: '970', i10n: 'PS' },
    { name: { en: 'Panama' }, countryCode: '507', i10n: 'PA' },
    { name: { en: 'Papua New Guinea' }, countryCode: '675', i10n: 'PG' },
    { name: { en: 'Paraguay' }, countryCode: '595', i10n: 'PY' },
    { name: { en: 'Peru' }, countryCode: '51', i10n: 'PE' },
    { name: { en: 'Philippines' }, countryCode: '63', i10n: 'PH' },
    { name: { en: 'Pitcairn' }, countryCode: '64', i10n: 'PN' },
    { name: { en: 'Poland' }, countryCode: '48', i10n: 'PL' },
    { name: { en: 'Portugal' }, countryCode: '351', i10n: 'PT' },
    { name: { en: 'Puerto Rico' }, countryCode: '1-787', i10n: 'PR' },
    { name: { en: 'Puerto Rico' }, countryCode: '1-939', i10n: 'PR' },
    { name: { en: 'Qatar' }, countryCode: '974', i10n: 'QA' },
    { name: { en: 'Republic of the Congo' }, countryCode: '242', i10n: 'CG' },
    { name: { en: 'Reunion' }, countryCode: '262', i10n: 'RE', flagCode: 'FR' },
    { name: { en: 'Romania' }, countryCode: '40', i10n: 'RO' },
    { name: { en: 'Russia' }, countryCode: '7', i10n: 'RU' },
    { name: { en: 'Rwanda' }, countryCode: '250', i10n: 'RW' },
    { name: { en: 'Saint Barthelemy' }, countryCode: '590', i10n: 'BL' },
    { name: { en: 'Saint Helena' }, countryCode: '290', i10n: 'SH' },
    { name: { en: 'Saint Kitts and Nevis' }, countryCode: '1-869', i10n: 'KN' },
    { name: { en: 'Saint Lucia' }, countryCode: '1-758', i10n: 'LC' },
    { name: { en: 'Saint Martin' }, countryCode: '590', i10n: 'MF' },
    { name: { en: 'Saint Pierre and Miquelon' }, countryCode: '508', i10n: 'PM' },
    { name: { en: 'Saint Vincent and the Grenadines' }, countryCode: '1-784', i10n: 'VC' },
    { name: { en: 'Samoa' }, countryCode: '685', i10n: 'WS' },
    { name: { en: 'San Marino' }, countryCode: '378', i10n: 'SM' },
    { name: { en: 'Sao Tome and Principe' }, countryCode: '239', i10n: 'ST' },
    { name: { en: 'Saudi Arabia' }, countryCode: '966', i10n: 'SA' },
    { name: { en: 'Senegal' }, countryCode: '221', i10n: 'SN' },
    { name: { en: 'Serbia' }, countryCode: '381', i10n: 'RS' },
    { name: { en: 'Seychelles' }, countryCode: '248', i10n: 'SC' },
    { name: { en: 'Sierra Leone' }, countryCode: '232', i10n: 'SL' },
    { name: { en: 'Singapore' }, countryCode: '65', i10n: 'SG' },
    { name: { en: 'Sint Maarten' }, countryCode: '1-721', i10n: 'SX' },
    { name: { en: 'Slovakia' }, countryCode: '421', i10n: 'SK' },
    { name: { en: 'Slovenia' }, countryCode: '386', i10n: 'SI' },
    { name: { en: 'Solomon Islands' }, countryCode: '677', i10n: 'SB' },
    { name: { en: 'Somalia' }, countryCode: '252', i10n: 'SO' },
    { name: { en: 'South Africa' }, countryCode: '27', i10n: 'ZA' },
    { name: { en: 'South Korea' }, countryCode: '82', i10n: 'KR' },
    { name: { en: 'South Sudan' }, countryCode: '211', i10n: 'SS' },
    { name: { en: 'Spain' }, countryCode: '34', i10n: 'ES' },
    { name: { en: 'Sri Lanka' }, countryCode: '94', i10n: 'LK' },
    { name: { en: 'Sudan' }, countryCode: '249', i10n: 'SD' },
    { name: { en: 'Suriname' }, countryCode: '597', i10n: 'SR' },
    { name: { en: 'Svalbard and Jan Mayen' }, countryCode: '47', i10n: 'SJ' },
    { name: { en: 'Swaziland' }, countryCode: '268', i10n: 'SZ' },
    { name: { en: 'Sweden' }, countryCode: '46', i10n: 'SE' },
    { name: { en: 'Switzerland' }, countryCode: '41', i10n: 'CH' },
    { name: { en: 'Syria' }, countryCode: '963', i10n: 'SY' },
    { name: { en: 'Taiwan' }, countryCode: '886', i10n: 'TW' },
    { name: { en: 'Tajikistan' }, countryCode: '992', i10n: 'TJ' },
    { name: { en: 'Tanzania' }, countryCode: '255', i10n: 'TZ' },
    { name: { en: 'Thailand' }, countryCode: '66', i10n: 'TH' },
    { name: { en: 'Togo' }, countryCode: '228', i10n: 'TG' },
    { name: { en: 'Tokelau' }, countryCode: '690', i10n: 'TK' },
    { name: { en: 'Tonga' }, countryCode: '676', i10n: 'TO' },
    { name: { en: 'Trinidad and Tobago' }, countryCode: '1-868', i10n: 'TT' },
    { name: { en: 'Tunisia' }, countryCode: '216', i10n: 'TN' },
    { name: { en: 'Turkey' }, countryCode: '90', i10n: 'TR' },
    { name: { en: 'Turkmenistan' }, countryCode: '993', i10n: 'TM' },
    { name: { en: 'Turks and Caicos Islands' }, countryCode: '1-649', i10n: 'TC' },
    { name: { en: 'Tuvalu' }, countryCode: '688', i10n: 'TV' },
    { name: { en: 'U.S. Virgin Islands' }, countryCode: '1-340', i10n: 'VI' },
    { name: { en: 'Uganda' }, countryCode: '256', i10n: 'UG' },
    { name: { en: 'Ukraine' }, countryCode: '380', i10n: 'UA' },
    { name: { en: 'United Arab Emirates' }, countryCode: '971', i10n: 'AE' },
    { name: { en: 'United Kingdom' }, countryCode: '44', i10n: 'GB' },
    { name: { en: 'United States' }, countryCode: '1', i10n: 'US' },
    { name: { en: 'Uruguay' }, countryCode: '598', i10n: 'UY' },
    { name: { en: 'Uzbekistan' }, countryCode: '998', i10n: 'UZ' },
    { name: { en: 'Vanuatu' }, countryCode: '678', i10n: 'VU' },
    { name: { en: 'Vatican' }, countryCode: '379', i10n: 'VA' },
    { name: { en: 'Venezuela' }, countryCode: '58', i10n: 'VE' },
    { name: { en: 'Vietnam' }, countryCode: '84', i10n: 'VN' },
    { name: { en: 'Wallis and Futuna' }, countryCode: '681', i10n: 'WF' },
    { name: { en: 'Western Sahara' }, countryCode: '212', i10n: 'EH' },
    { name: { en: 'Yemen' }, countryCode: '967', i10n: 'YE' },
    { name: { en: 'Zambia' }, countryCode: '260', i10n: 'ZM' },
    { name: { en: 'Zimbabwe' }, countryCode: '263', i10n: 'ZW' },
  ];

  public generateUrl() {
    this.getApplicationById = this.applicationServerUrl + this.applicationServerVersion + '/applications/{applicationId}';

    this.getBookingApiKey = this.linebertyServerUrl + this.linebertyApiVersion + '/lineberty/b/apiKey';
    this.getValidationApiKey = this.linebertyServerUrl + this.linebertyApiVersion + '/lineberty/v/apiKey';
    this.createUser = this.linebertyServerUrl + this.linebertyApiVersion + '/lineberty/b/create';
    this.logUser = this.linebertyServerUrl + this.linebertyApiVersion + '/lineberty/b/login';
    this.refreshUserToken = this.linebertyServerUrl + this.linebertyApiVersion + '/lineberty/b/refreshToken';
    this.verifyJWT = this.linebertyServerUrl + this.linebertyValidationApiVersion + '/jwt/verify';

    this.getPlaceFromPlaceName = this.linebertyServerUrl + this.linebertyApiVersion + '/places/placeName/{placeName}';

    this.preLogin = this.linebertyValidationServer + this.linebertyValidationApiVersion + '/operator/preLogin';
    this.loginOperator = this.linebertyValidationServer + this.linebertyValidationApiVersion + '/operator/endpoint/{endpointId}/login';
    this.assignToEndpoint = this.linebertyValidationServer + this.linebertyValidationApiVersion + '/operator/session/assignToEndpoint';
    this.logoutOperator = this.linebertyValidationServer + this.linebertyValidationApiVersion + '/operator/session';
    this.refreshOperatorToken = this.linebertyValidationServer + this.linebertyValidationApiVersion + '/operator/session/refreshToken';
    this.operatorRoles = this.linebertyValidationServer + this.linebertyValidationApiVersion + '/operator/roles';
    this.operatorAccount = this.linebertyValidationServer + this.linebertyValidationApiVersion + '/operator/account';

    this.getPlace = this.linebertyValidationServer + this.linebertyValidationApiVersion + '/places/{placeId}';
    this.getPlaceTimeslots = this.linebertyValidationServer + this.linebertyValidationApiVersion + '/places/{placeId}/timeslots';
    this.getQueue = this.linebertyValidationServer + this.linebertyValidationApiVersion + '/queues/{queueId}';
    this.getCounters = this.linebertyValidationServer + this.linebertyValidationApiVersion + '/counters';
    this.getQueueEndpoints = this.linebertyValidationServer + this.linebertyValidationApiVersion + '/queues/{queueId}/endpoints';
    this.getEndpoint = this.linebertyValidationServer + this.linebertyValidationApiVersion + '/endpoints/{endpointId}';
    this.getEndpointSse = this.linebertyValidationServer + this.linebertyValidationApiVersion + '/endpoints/{endpointId}/sse';
    this.getEndpointTimeslots = this.linebertyValidationServer + this.linebertyValidationApiVersion + '/endpoints/{endpointId}/timeslots';
    this.setEndpointTimeslots = this.linebertyValidationServer + this.linebertyValidationApiVersion + '/endpoints/{endpointId}/timeslots';
    this.deleteEndpointTimeslots = this.linebertyValidationServer + this.linebertyValidationApiVersion + '/endpoints/{endpointId}/timeslots';
    this.getIndicators = this.linebertyValidationServer + this.linebertyValidationApiVersion + '/queues/{queueId}/indicators';
    this.openEndpoint = this.linebertyValidationServer + this.linebertyValidationApiVersion + '/endpoints/{endpointId}';
    this.getDoneTickets = this.linebertyValidationServer + this.linebertyValidationApiVersion + '/queues/{queueId}/tickets/history';
    this.getCurrentsTickets = this.linebertyValidationServer + this.linebertyValidationApiVersion + '/queues/{queueId}/tickets/currents';
    this.getCurrentsTicketsSse = this.linebertyValidationServer + this.linebertyValidationApiVersion + '/queues/{queueId}/tickets/currents/sse';
    this.getCounterSse = this.linebertyValidationServer + this.linebertyValidationApiVersion + '/counters/sse';
    this.incrementCounter = this.linebertyValidationServer + this.linebertyValidationApiVersion + '/counters/{counterId}';
    this.decrementCounter = this.linebertyValidationServer + this.linebertyValidationApiVersion + '/counters/{counterId}';
    this.searchTickets = this.linebertyValidationServer + this.linebertyValidationApiVersion + '/queues/{queueId}/tickets/search';
    this.setTicketExtendedAttributes = this.linebertyValidationServer + this.linebertyValidationApiVersion + '/tickets/{ticketId}/extendedAttributes';
    this.setTicketState = this.linebertyValidationServer + this.linebertyValidationApiVersion + '/tickets/{ticketId}/states';

    this.getTicketsV1 = this.linebertyBookingServer + this.linebertyBookingApiVersionV1 + '/user/tickets';
    this.getQueuesOfPlaceV1 = this.linebertyBookingServer + this.linebertyBookingApiVersionV1 + '/places/{placeId}/queues';
    this.getQueueAvailabilitiesV1 = this.linebertyBookingServer + this.linebertyBookingApiVersionV1 + '/queues/{queueId}/appointmentTypes/{appointmentTypeId}/groupSize/{groupSize}/availabilities';
    this.getQueueBookingV1 = this.linebertyBookingServer + this.linebertyBookingApiVersionV1 + '/queues/{queueId}';
    this.getQueuesStateSseV1 = this.linebertyBookingServer + this.linebertyBookingApiVersionV1 + '/queues/state/sse';
    this.bookingTicketV1 = this.linebertyBookingServer + this.linebertyBookingApiVersionV1 + '/queues/{queueId}/ticket';
    this.cancelTicketV1 = this.linebertyBookingServer + this.linebertyBookingApiVersionV1 + '/user/tickets/{ticketId}/cancel';

    this.getTicketsV2 = this.linebertyBookingServer + this.linebertyBookingApiVersionV2 + '/user/tickets';
    this.getQueuesOfPlaceV2 = this.linebertyBookingServer + this.linebertyBookingApiVersionV2 + '/places/{placeId}/queues';
    this.getQueueAvailabilitiesV2 = this.linebertyBookingServer + this.linebertyBookingApiVersionV2 + '/queues/{queueId}/availabilities';
    this.getQueueDaysWithAvailabilitiesV2 = this.linebertyBookingServer + this.linebertyBookingApiVersionV2 + '/queues/{queueId}/daysWithAvailabilities';
    this.getQueueBookingV2 = this.linebertyBookingServer + this.linebertyBookingApiVersionV2 + '/queues/{queueId}';
    this.getQueuesStateSseV2 = this.linebertyBookingServer + this.linebertyBookingApiVersionV2 + '/queues/state/sse';
    this.bookingTicketV2 = this.linebertyBookingServer + this.linebertyBookingApiVersionV2 + '/queues/{queueId}/ticket';
    this.cancelTicketV2 = this.linebertyBookingServer + this.linebertyBookingApiVersionV2 + '/user/tickets/{ticketId}/cancel';

    this.getQueueVersion = this.bookingServerUrl + this.bookingServerVersion + '/queues/versions';
    this.openBooking = this.timetableServerUrl + this.timetableServerVersion + '/queueBooking/{queueId}/openBookingForTheDay';
    this.closeBooking = this.timetableServerUrl + this.timetableServerVersion + '/queueBooking/{queueId}/closeBookingForTheDay';
    this.getEndpointConfig = this.endpointServerUrl + this.endpointServerVersion + '/endpoints/{endpointId}/configuration';
  }

  colorPaletteTheme: any = {
    primaryPalette: '#5511ef',
    accentPalette: '#FFFFFF',
    warnPalette: 'red',
    customProperties: {
      'primary-bg': '#ffffff',
      'primary-textColor': '#000000',
      'secondary-bg': '#3897a7',
      'secondary-textColor': '#ffffff',
      'tertiary-bg': '#f8f8f8',
      'tertiary-textColor': '#404040',
      'border-textColor': '#a78f80',
      'text-color': '#a78f80',
      'title-textColor': '#000000',
      'subTitle-textColor': '#404040',
      'primary-button-bg': '#aa192d',
      'primary-button-textColor': '#ffffff',
      'secondary-button-bg': '#a78f80',
      'secondary-button-textColor': '#ffffff',
    },
  };
}